import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=cb2c71b8"
import script from "./projectlist.vue?vue&type=script&lang=js"
export * from "./projectlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports